<div *ngIf="collabs && tenant">
  <app-tenant-info-component [collabs]="collabs" [tenantName]="tenant.name">
  </app-tenant-info-component>
</div>
